require('./angular');
module.exports = angular;



//////////////////
// WEBPACK FOOTER
// ./bower_components/angular/index.js
// module id = 151
// module chunks = 0